export function initSingleProductTabs() {
    const tabBtns = document.querySelectorAll('.tab-btn');
    const tabContents = document.querySelectorAll('.tab-content');

    // Red de seguridad: Si no estamos en la página del producto y no hay tabs, detenemos la función aquí.
    if (tabBtns.length === 0) return; 

    tabBtns.forEach(btn => {
        btn.addEventListener('click', function() {
            const targetId = this.getAttribute('data-target');

            // 1. Reiniciar todos los botones (estado inactivo)
            tabBtns.forEach(b => {
                b.classList.remove('border-[#4A9C2E]', 'text-[#4A9C2E]');
                b.classList.add('border-transparent', 'text-[#4A5565]');
            });

            // 2. Ocultar todos los contenidos
            tabContents.forEach(content => {
                content.classList.remove('block');
                content.classList.add('hidden');
            });

            // 3. Activar el botón clickeado (color verde)
            this.classList.remove('border-transparent', 'text-[#4A5565]');
            this.classList.add('border-[#4A9C2E]', 'text-[#4A9C2E]');

            // 4. Mostrar el contenido correspondiente
            const targetContent = document.getElementById(targetId);
            if (targetContent) {
                targetContent.classList.remove('hidden');
                targetContent.classList.add('block');
            }
        });
    });
}